export type ListType = 'all' | 'liked'
export interface State {
  listType: ListType
}

export const initialState: State = {
  listType: 'all',
}
